const FULL_WIDTH_LAYOUT_ROUTES = new Set(["/onboarding"])

const SIDEBAR_OFFSET = 60

const getLayoutConfig = pathname => {
  const showSidebar = !FULL_WIDTH_LAYOUT_ROUTES.has(pathname)

  return {
    showSidebar,
    contentLeftOffset: showSidebar ? SIDEBAR_OFFSET : 0,
  }
}

export { FULL_WIDTH_LAYOUT_ROUTES, SIDEBAR_OFFSET, getLayoutConfig }
